module.exports = __webpack_public_path__ + "images/traffic-35ca6614.svg";